export default "__VITE_ASSET__B_AS$m26__"